import * as Sentry from '@sentry/react'

const SetupSentry = ({ appName }: { appName: string }): JSX.Element => {
  Sentry.setTag('subapp', appName)
  return <></>
}

export default SetupSentry
